export default {
    state:{
        mac: '',
        detailUserId: '',
        optionsOldMan: '',
        SchedulingDate : '',
        personalStatus: '' ,

    },
    mutations:{
        getDetailMac(state,mac) {
            state.mac = mac ;
        },
        getDetailUserId(state,detailUserId){
            state.detailUserId = detailUserId ;
        },
        getOptionsOldMan(state,optionsOldMan) {
            state.optionsOldMan = optionsOldMan
        },
        getSchedulingDate(state,SchedulingDate) {
          state.SchedulingDate = SchedulingDate
        },
        getPersonalStatus(state,personalStatus) {
          state.personalStatus = personalStatus ;
        }

    },
    action:{

    },
    getter:{

    }
  }



// WEBPACK FOOTER //
// ./src/store/modules/serviceDemandDetail.js